// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';
import {readRegistrationStatusList} from '../../shared/repositories';

export const readRegistrationStatuses = () =>
    dispatch => {

        dispatch({
            type: actions.INCREASE_BUSY_COUNTER
        });

        return readRegistrationStatusList()
            .then(data => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

                dispatch({
                    data,
                    type: actions.READ_REGISTRATION_STATUSES_SUCCESS
                });

            })
            .catch(() => {

                dispatch({
                    type: actions.DECREASE_BUSY_COUNTER
                });

            });

    };




// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/read-registration-statuses.js